import type { BaseColumnData } from './column-data';
import type { Nullish } from 'cesg-shared';

export function filterTableData<T>(
  data: T[],
  columns: BaseColumnData[],
  query: string
): T[] {
  const lowerQuery = query?.toLowerCase() || '';

  if (!lowerQuery) return [...data];

  return data.filter((row) => {
    const rowObj = row as Record<string, unknown>;

    return columns.some((column) => {
      const rawValue = rowObj[column.key];
      const formattedValue = column.format
        ? column.format(rawValue as Nullish<string | number>)
        : rawValue;

      return [rawValue, formattedValue]
        .filter((v) => v != null)
        .some((val) => val.toString().toLowerCase().includes(lowerQuery));
    });
  });
}
